import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from '../../../../assets/js/vendor/react.development';
import clsx from 'clsx';
export function CheckboxField({ name, value = name, labelHtmlText, required, autoFocus, handleInputChange, handleInputBlur, disabled, defaultChecked, errors, validateInput, }) {
    const hasErrors = Boolean(errors === null || errors === void 0 ? void 0 : errors.length);
    function onChange(e) {
        if (handleInputChange) {
            handleInputChange(e);
        }
        // Only validate on change when there are errors:
        if (hasErrors && validateInput) {
            const el = e.target;
            validateInput(el);
        }
    }
    return (_jsxs(_Fragment, { children: [_jsxs("span", Object.assign({ className: "ktc-checkbox" }, { children: [_jsx("input", { type: "checkbox", className: clsx('form-control', hasErrors && 'input-validation-error'), name: name, id: value, value: value, required: required, onChange: onChange, onBlur: handleInputBlur, autoFocus: autoFocus, disabled: disabled, defaultChecked: defaultChecked }), _jsx("label", { htmlFor: value, dangerouslySetInnerHTML: { __html: labelHtmlText } })] })), hasErrors && (_jsx("div", Object.assign({ className: "field-validation-error" }, { children: errors.map((error) => (_jsxs(Fragment, { children: [error, _jsx("br", {})] }, error))) })))] }));
}
